/* eslint-disable react/destructuring-assignment */
/* eslint-env browser */
import { PopupButton } from '@typeform/embed-react'
import request from 'axios'
import PropTypes from 'prop-types'
import * as React from 'react'

const Counterpart = require('@gandi/counterpart').Instance

const ModalsHelper = require('../../../client/clientjs/utils/modals')

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

function closeModal() {
  ModalsHelper.close('#modal-register-contest')
}

class LoginForm extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      didRegister: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (this.props.appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(this.props.appConfig.locale.identifierShort)
    }
  }

  handleSubmit() {
    const { contestDefautToPreRegister, contestId, isLoggedIn } = this.props
    if (!isLoggedIn) {
      ModalsHelper.open('#modal-signup')
      closeModal()
      return
    }
    const { loading } = this.state
    if (loading) {
      return
    }
    try {
      this.setState({ loading: true })
    } catch (e) {
      console.log('error while setting state, lets say we dont actually care', e)
    }
    request
      .post(`/api/contests/${contestId}/register`)
      .then(() => {
        this.setState({ didRegister: true })
        if (contestDefautToPreRegister) {
          window.location.reload()
        }
        setTimeout(() => {
          window.location.reload()
        }, 4000)
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    const { loading, didRegister } = this.state
    const { contestDefautToPreRegister, contestRegisterFormSettings, appConfig, isLoggedIn } = this.props
    let { alreadyRegistered, alreadyPreRegistered = {} } = this.props

    if (contestDefautToPreRegister) {
      alreadyPreRegistered = didRegister || alreadyPreRegistered
    } else {
      alreadyRegistered = didRegister || alreadyRegistered
    }

    let emptyTitle = ''

    if (alreadyRegistered) {
      emptyTitle = 'Vous êtes inscrit !'
    } else if (alreadyPreRegistered) {
      emptyTitle = 'Vous êtes pré-inscrit !'
    } else {
      emptyTitle = "Vous n'êtes pas encore inscrit !"
    }

    return (
      <div>
        <header className="modal-card-head">
          <p className="modal-card-title has-text-weight-bold">
            {contestDefautToPreRegister ? 'Pré-inscrivez-vous !' : 'Inscrivez-vous pour participer !'}
          </p>
          <button
            onClick={closeModal}
            type="button"
            className="delete"
            aria-label="close"
            data-close-modal="modal-register-contest"
          />
        </header>
        <div className="modal-card-body">
          <div className="content">
            <p className="title is-5">{emptyTitle}</p>
            <p
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: alreadyRegistered ? this.props.texts.alreadyRegistered : this.props.texts.notRegistered,
              }}
            />
            <div className="has-text-centered">
              {alreadyRegistered && (
                <span className="icon has-text-success">
                  <i className="fas fa-check fa-3x" />
                </span>
              )}
              {!(alreadyRegistered || alreadyPreRegistered) && (
                <div className="has-text-centered">
                  {contestRegisterFormSettings?.typeformId && isLoggedIn ? (
                    <PopupButton
                      id={contestRegisterFormSettings.typeformId}
                      style={{ fontSize: 20 }}
                      className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
                      onSubmit={this.handleSubmit}
                      hidden={{
                        ffuserid: appConfig.userId,
                        ffemail: appConfig.userEmail,
                      }}
                    >
                      <b>{contestDefautToPreRegister ? 'Pré-inscription' : "Je m'inscris !"}</b>
                    </PopupButton>
                  ) : (
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
                    >
                      <b>{contestDefautToPreRegister ? 'Pré-inscription' : "Je m'inscris !"}</b>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

LoginForm.propTypes = {
  appConfig: PropTypes.object.isRequired,
  contestId: PropTypes.string.isRequired,
  contestDefautToPreRegister: PropTypes.bool,
  contestRegisterFormSettings: PropTypes.object,
  alreadyPreRegistered: PropTypes.bool,
  alreadyRegistered: PropTypes.bool.isRequired,
  texts: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}

LoginForm.defaultProps = {
  alreadyPreRegistered: false,
  contestDefautToPreRegister: false,
  contestRegisterFormSettings: null,
}

module.exports = LoginForm
